import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input as InputBootstrap } from 'reactstrap';
import './Input.scss';

const noop = () => {};

class Input extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    inputRef: PropTypes.func,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
    invalid: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    onBlur: noop,
    onFocus: noop,
    onKeyDown: noop,
    inputRef: noop,
    disabled: false,
    placeholder: '',
    style: {},
    type: 'text',
    invalid: false,
    className: '',
  };

  focus() {
    this.input.focus();
  }

  ref = node => {
    if (!node) return;

    this.input = node;
    this.props.inputRef(node);
  };

  render() {
    const {
      value,
      onChange,
      onBlur,
      onFocus,
      inputRef,
      onKeyDown,
      disabled,
      placeholder,
      style,
      type,
      invalid,
      className,
      maxLength,
      ...props
    } = this.props;

    return (
      <InputBootstrap
        {...props}
        className={classnames('reactstrap-input', className, {
          'reactstrap-input--invalid': invalid,
        })}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        value={value}
        type={type}
        maxLength={maxLength}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        innerRef={this.ref}
        autoComplete="none"
      />
    );
  }
}

export default Input;
